/**
 *
 *
 * @param { SunModelState } state
 * @return { string }
 */
export function nodes(state) {
  return [
    ...state.sunModel.data.facts.map(f => ({...f, type: 'fact'})),
    ...state.sunModel.data.dimensions.map(d => ({...d, type: 'dimension'})),
  ];
}

export function links(state) {
  return [
    ...state.sunModel.data.links.map(l => ({source: l.table, target: l.dimension})),
  ];
}

export function tagsAsMap(state) {
  return new Map(state.tags.data.map(t => [t.tagId, t]));
}
